import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = ['labelInputs', 'labelInputsFrame', 'pendingOverlay']

  refreshLabelInputs(event) {
    const input = event.currentTarget
    const params = new URLSearchParams()
    params.set('label_template[label_group_id]', input.value)

    enter(this.pendingOverlayTarget)
    this.labelInputsFrameTarget.src =
      `${input.dataset.refreshPath}?${params.toString()}`
  }
}
